import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const SearchWidgetActions = {
    initialiseIFrameWidget() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEARCH_WIDGET_LOADED
        });
    }
};

export default SearchWidgetActions;



// WEBPACK FOOTER //
// ./src/actions/SearchWidgetActions.js